export default __webpack_public_path__ + "static/media/SEN-TEM-PROBE.423c5b9b.png";